import React, { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "antd";
import { Input, Checkbox } from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import HorizontalSpacer from "../../../components/layouts/HorizontalSpacer";
import RestrictedComponent from "../../../components/util/RestrictedComponent";

import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { reload, setTextFilter } from "../tasksSlice";

const Header = (props) => {
  const {
    onAddClick,
    onInactiveChange,
    showInactive,
    onMyTasksChange,
    showMyTasks,
  } = props;

  const dispatch = useDispatch();
  const { page: tasksPage } = useSelector((state) => state.tasks);
  const { filter } = tasksPage;
  const inputRef = useRef();

  const direction = useSelector(
    (state) => state.user.currentAppLocale.direction
  );
  const intl = useIntl();

  useEffect(() => {
    if (inputRef && inputRef.current) {
      const { input } = inputRef.current;
      input.focus();
    }
  }, []);

  const onTextChange = (e) => {
    dispatch(
      setTextFilter({
        filter: e.target.value,
      })
    );
  };

  const AddBtn = () => (
    <Button
      style={{ margin: "0 10px" }}
      type="primary"
      onClick={onAddClick}
      size="large"
    >
      <PlusOutlined /> {<FormattedMessage id="app.tasks.addNewTask" />}
    </Button>
  );

  return (
    <HorizontalSpacer style={{ paddingBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Input
          prefix={
            <SearchOutlined style={{ padding: "0  5px", opacity: 0.4 }} />
          }
          placeholder={intl.formatMessage({
            id: "app.tasks.searchPlaceholder",
          })}
          value={filter.freeText}
          onChange={onTextChange}
          style={{ width: 300 }}
          size="large"
          allowClear
          ref={inputRef}
        />

        <Checkbox
          style={{ margin: "0 20px" }}
          onChange={onInactiveChange}
          checked={showInactive}
        >
          {intl.formatMessage({
            id: "app.tasks.showInactive",
          })}
        </Checkbox>
        <Checkbox
          style={{ margin: "0 20px" }}
          onChange={onMyTasksChange}
          checked={showMyTasks}
        >
          {intl.formatMessage({
            id: "app.tasks.showMyTasks",
          })}
        </Checkbox>
      </div>
      <div style={{ display: "flex" }}>
        <RestrictedComponent
          resource={"tasks"}
          action={"editor"}
          comp={<AddBtn />}
        >
          <AddBtn />
        </RestrictedComponent>

        <Button
          type="text"
          onClick={() => dispatch(reload())}
          size="large"
          shape="circle"
          icon={
            <ReloadOutlined
              className={direction === "rtl" ? "reloadRtl" : "reload"}
            />
          }
        />
      </div>
    </HorizontalSpacer>
  );
};

export default Header;
